import { listSubheaderClasses, MenuListProps } from '@rossum/ui/material';

export const menuListSharedProps: Partial<MenuListProps> = {
  sx: {
    background: 'inherit',
    [`.${listSubheaderClasses.root}`]: {
      color: 'text.secondary',
    },
  },
};
